import React, { useState } from "react";
import { Plus } from "react-feather";
import Sidebar from "./AdminComp/Sidebar";
import BreadCrumb from "./AdminComp/BreadCrumb";
import defaultprofile from "../../component/img/defaultprofile.webp";

function AdminProfile() {
  const [profileImage, setProfileImage] = useState(null);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    setProfileImage(URL.createObjectURL(file)); // Preview image after upload
  };

  return (
    <>


<div className="App" style={{ display: "flex" }}>
         <Sidebar/>

        {/* Content area */}
        <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
          <div>
           <BreadCrumb/>
            <div className="container-fluid">
              <div className="crdmain mb-2">
              <div
  className="d-flex justify-content-between align-items-center"
  style={{ width: "100%" }}
>
  <h2 className="chart-title mb-0">My Profile</h2>
  <div className="ms-auto">  
  </div>
</div>

                <div className="row g-2 mt-0 mb-0">
                  <div className="col-md-12 p-2">
 {/* User/Agent Form */}
 <div className=" ">
        <form>
          <div className="row g-1 text-start">

            <div className="col-md-9 rtqq1">
                <div className="row g-1">
                    {/* Agent Name */}
            <div className="col-md-12">
              <label className="text-dark mb-1 labelset2 font3">Name</label>
              <input type="text" className="input1" placeholder="Enter name" />
            </div>

            {/* Phone */}
            <div className="col-md-6">
              <label className="text-dark mb-1 labelset2 font3">Phone</label>
              <input type="text" className="input1" placeholder="Enter phone" />
            </div>

            {/* Email */}
            <div className="col-md-6">
              <label className="text-dark mb-1 labelset2 font3">Email</label>
              <input type="email" className="input1" placeholder="Enter email" />
            </div>

            {/* Address */}
            <div className="col-md-12">
              <label className="text-dark mb-1 labelset2 font3">Address</label>
              <input type="text" className="input1" placeholder="Enter address" />
            </div>

            {/* City */}
            <div className="col-md-4">
              <label className="text-dark mb-1 labelset2 font3">City</label>
              <input type="text" className="input1" placeholder="Enter city" />
            </div>

            {/* State */}
            <div className="col-md-4">
              <label className="text-dark mb-1 labelset2 font3">State</label>
              <input type="text" className="input1" placeholder="Enter state" />
            </div>

            {/* Country */}
            <div className="col-md-4">
              <label className="text-dark mb-1 labelset2 font3">Country</label>
              <input type="text" className="input1" placeholder="Enter country" />
            </div>

            {/* Pincode */}
            <div className="col-md-4">
              <label className="text-dark mb-1 labelset2 font3">Pincode</label>
              <input type="text" className="input1" placeholder="Enter pincode" />
            </div>
                </div>
            </div>
            <div className="col-md-3">
            {/* Profile Image Upload */}
            <div className="col-md-12">
              <label className="text-dark mb-1 labelset2 font3">Profile Image</label>
              <div className="profile-image-upload">
                <div className="profile-image-box">
                  {profileImage ? (
                    <img src={profileImage} alt="Profile Preview" className="profile-image" />
                  ) : (
                    <span className="upload-text"><img src={defaultprofile} className="img-fluid"/></span>
                  )}
                </div>

                {/* Custom Upload Button */}
                <button
                  type="button"
                  className="upload-button"
                  onClick={() => document.getElementById("profile-image-input").click()}
                >
                  Upload Image
                </button>
                <input
                  type="file"
                  id="profile-image-input"
                  accept="image/*"
                  onChange={handleImageUpload}
                  style={{ display: "none" }} // Hide the default file input
                />
              </div>
            </div> 
            </div>
            

         
            
          </div>

          {/* Submit Button */}
          <div className="text-end">
            <button type="submit" className="submit-btn mt-3">
              Save Changes
            </button>
          </div>
        </form>
      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


 
      
    </>
  );
}

export default AdminProfile;
